module.exports = __webpack_public_path__ + "detail.svg?0600a6f450252d96379f9f808a2618a2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/detail.svg
// module id = 121
// module chunks = 0